import ToastContainer from './toast-container';

const Toast = {
  install(Vue) {
    Vue.component('ToastContainer', ToastContainer);

    this.container = undefined;

    Vue.prototype.$toast = {
      setContainer(container) {
        if (Toast.container === undefined) {
          Toast.container = container;
        } else {
          console.warn('Toast component set more than once.');
        }
      },
      show(type, message, timeout = null) {
        if (Toast.container) {
          Toast.container.show(type, message, timeout);
        } else {
          throw new Error('You must put a <toast-container /> somewhere in your template.');
        }
      },
    };
  },
};

export default Toast;
